// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"8714cd09","977":"4195db60"}[chunkId] + ".chunk.js";
};